const MgBusinessCaseContent = {
  PRODUCT_FEATURES: {
    description:
      "As the Head of Products, you have to decide on your product’s features. Each product you develop has 4 features and you have to decide which features are important for your product by ranking each from 1 to 10 (1= lowest importance, 10= highest importance).",
    mgAbout: "your product features",
    mgSection: "Product"
  },
  PROMOTIONAL_SPEND: {
    description:
      "As the Head of Product Marketing, you have to decide how much to spend on promoting your product and which channels to use to promote your product - Traditional or Digital Marketing Channels.",
    mgAbout: "promotional spend",
    mgSection: "Marketing"
  },
  SALES_SPEND: {
    description:
      "As the Head of Product Marketing, you have to decide which sales channels to use to sell your product. You have a choice of direct sales (i.e. selling directly to the customer) or distributor (i.e. selling through a third party/agent).",
    mgAbout: "sales spend",
    mgSection: "Marketing"
  }
};

export default MgBusinessCaseContent;



// WEBPACK FOOTER //
// ./src/components/typeform/MgBusinessCaseContent.js